import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: 'center',
    userSelect: 'none',
  },
  svgWrapper: {
    position: 'relative',
    display: 'inline-block',
    cursor: 'pointer',
    transition: 'transform 0.15s ease-in-out',
    '&:hover': {
      transform: 'scale(1.05)',
    },
  },
}))
